import React, { Component } from 'react';
import { Icon } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import Accordion from '@zippytech/react-toolkit/Accordion';
import '@zippytech/react-toolkit/Accordion/index.css';

import Description from '../../contentManager/ResourcePane/ContentDetail/Description'
import Summary from '../../contentManager/ResourcePane/ContentDetail/Summary'
import Detail from '../../contentManager/ResourcePane/ContentDetail/Detail'

import AccessControlUpdateModal from "./IndesignComponent/AccessControlUpdateModal"
import AccessControl from './SummaryView/AccessControl'


class SummaryView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            KBOpne: false,
            type: null
        }
    }

    handleModalKB = (open, type, page) => {
        this.setState({
            KBOpne: open,
            type: type,
            page: page
        })
    }

    updateCategory = (data) => {
        let payload = {
            _id: this.props.selectedContent._id,
            data: {
                baseCategory: data.k,
                category: data.c,
                subCategory: data.s
            }
        }

        if (data.scope && this.state.type === "scope") {
            payload.data.scope = data.scope === "Private" ? "Public" : "Private"
        }
        dispatch.content.updateCategoryContents(payload)
        this.setState({ KBOpne: false })
    }

    render() {

        const expandTool = <div className="plusMinusIcons"  >
            <Icon className="close" name="plus circle" />
            <Icon className="open" name="minus circle" />
        </div>

        return (

            <div className="accordianBox w_100">
                <div className="accordianPanel w_100">
                    <Accordion expandTool={expandTool} horizontal className="practiceFlowResourcePane" enableKeyboardNavigation={false}>
                        <div tabTitle="Summary">
                            <div className="acc-header">Summary</div>
                            <Summary {...this.props} />
                        </div>
                        <div tabProps={{ title: 'Details' }}>
                            <div className="acc-header">Details</div>
                            <Detail {...this.props} />
                        </div>
                        <div tabProps={{ title: 'Description' }}>
                            <div className="acc-header">Description</div>
                            <Description {...this.props} />
                        </div>
                        <div tabProps={{ title: 'Publishing / Category' }}>
                            <div className="acc-header">Publishing / Category</div>
                            <div className="resourcePaneOverflow">
                                <AccessControl
                                    selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                                    selectedAccount={this.props.selectedAccount}
                                    selectedOrganisation={this.props.selectedOrganisation}
                                    user={this.props.user}
                                    scope={this.props.selectedContent.scope}
                                    baseCategory={this.props.selectedContent.baseCategory}
                                    category={this.props.selectedContent.category}
                                    subCategory={this.props.selectedContent.subCategory}
                                    handleModalKB={this.handleModalKB} />
                                <AccessControlUpdateModal
                                    baseCategoriesArr={this.props.baseCategoriesArr}
                                    status={this.props.selectedContent.status}
                                    user={this.props.user}
                                    publicCategoryList={this.props.publicCategoryList}
                                    handleModalKB={this.handleModalKB}
                                    updateCategory={this.updateCategory}
                                    open={this.state.KBOpne}
                                    type={this.state.type}
                                    page={this.state.page}
                                    scope={this.props.selectedContent.scope}
                                    baseCategory={this.props.selectedContent.baseCategory}
                                    category={this.props.selectedContent.category}
                                    subCategory={this.props.selectedContent.subCategory}
                                />
                            </div>
                        </div>
                    </Accordion>
                </div>
            </div>
        )
    }
}

export default SummaryView;